export default __webpack_public_path__ + "static/media/keerthan.ffdc64ec.jpg";